<template>
  <div class="sheader-frame" :class="{show: show}" ref="sub">
    <transition name="fade">
      <div class="sheader" v-show="show">
        <span v-html="profile.title"/><span class="sep">/</span><span v-html="profile.experience"/>
      </div>
    </transition>
  </div>
</template>

<script>

export default {
  name: 'subHeader',
  props: {
    observe: {
      type: String
    },
    profile: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      show: false
    }
  },
  methods: {
    needToShow (elt) {
      if (elt && this.$refs.sub) {
        const rect1 = elt.getBoundingClientRect()
        const target = this.$refs.sub.offsetTop + (this.$refs.sub.clientHeight / 2)
        this.show = rect1.bottom <= target
        // console.log('%s - %s : %s', rect1.bottom, elt.offsetTop, this.$refs.sub.clientHeight, this.$refs.sub.offsetTop)
      }
    }
  },
  mounted: function () {
    if (this.observe) {
      console.log('Recuperation elt', this.observe)
      const elt = document.getElementById(this.observe)
      if (elt) {
        document.addEventListener('scroll', () => {
          this.needToShow(elt)
        })
      }
    }
  }
}
</script>

<style scoped>
.sheader-frame {
  position: fixed;
  top: 4.5rem;
  width: 100%;
  background-color: black;
  z-index: 1;
  border-bottom: 1px solid black;
  padding: 0.5rem 2rem;
  height: 1.25rem;
}

.sheader-frame.show {
  border-bottom: 1px solid #fd4900;
}

.sheader {
  max-width: 1024px;
  margin: auto;
  color: #bbb;
  font-weight: 100;
}

.sep {
  color: #fd4900;
  padding: 0 0.5rem;
}

.fade-enter-active {
  transition: opacity .5s linear;
}

.fade-leave-active {
  transition: opacity 0 linear;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// SubHeader.vue?3dc0d9cc